export default {
    getQueryString(params) {
        let keys = Object.keys(params);
        let str ='';
        for(let i=0; i<keys.length; i++){
            if(i===0){
                str+=keys[i]+"="+ params[keys[i]]
            }
            else{
                str+="&"+keys[i]+"="+ params[keys[i]]
            }
        }

        return str===''?str:'?'+str;
    },
    getParams(url) {
        let arr = url.split('?');
        let paramObj = {}
        if(arr.length>1){
            const keyValueArr = arr[1].split('&')
            keyValueArr.forEach(item => {
                const keyValue = item.split('=')
                paramObj[keyValue[0]] = keyValue[1]
            })
        }

        return paramObj
    },
    setWechatTitle(title) {
        document.title = title;
        let mobile = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(mobile)) {
            let iframe = document.createElement('iframe');
            iframe.style.visibility = 'hidden';
            // 替换成站标favicon路径或者任意存在的较小的图片即可
            iframe.setAttribute('src', '//m.baidu.com/favicon.ico');
            let iframeCallback = function() {
                setTimeout(function() {
                    iframe.removeEventListener('load', iframeCallback)
                    document.body.removeChild(iframe)
                }, 10)
            };
            iframe.addEventListener('load', iframeCallback)
            document.body.appendChild(iframe)
        }
    },
    forEach(arr, fn){
        if (!arr.length || !fn) return
        let i = -1
        let len = arr.length
        while (++i < len) {
            let item = arr[i]
            fn(item, i, arr)
        }
    },
    isPoneAvailable($phone) {
        let myreg=/^[1][0-9][0-9]{9}$/;
        if (!myreg.test($phone)) {
            return false;
        } else {
            return true;
        }
    },
    format_date(timeStamp) {// 时间格式化
        let date = new Date(timeStamp);
        return date.getFullYear() + "年"
            + prefix_zero(date.getMonth() + 1) + "月"
            + prefix_zero(date.getDate()) + "日 "
            + prefix_zero(date.getHours()) + ":"
            + prefix_zero(date.getMinutes());
    },
    prefix_zero(num) {// 数字格式化
        return num >= 10 ? num : "0" + num;
    },
    /**
     * 节流函数--规定在一个单位时间内，只能触发一次函数。如果这个单位时间内触发多次函数，只有一次生效。
     */
    throttle(fun, delay) {//节流函数--规定在一个单位时间内，只能触发一次函数。如果这个单位时间内触发多次函数，只有一次生效。
        let last, deferTimer
        return function (args) {
            let that = this
            let _args = arguments
            let now = +new Date()
            if (last && now < last + delay) {
                clearTimeout(deferTimer)
                deferTimer = setTimeout(function () {
                    last = now
                    fun.apply(that, _args)
                }, delay)
            } else {
                last = now
                fun.apply(that, _args)
            }
        }
    },
    debounce(fun, delay) {//防抖函数--在事件被触发n秒后再执行回调，如果在这n秒内又被触发，则重新计时
        return function (args) {
            let that = this
            clearTimeout(fun.id)
            fun.id = setTimeout(function () {
                fun.call(that, args)
            }, delay)
        }
    },
    bubbleSort(arr) { // 冒泡排序
        for (let i = arr.length - 1; i > 0; i--) {
            for (let j = 0; j < i; j++) {
                if (arr[j] > arr[j + 1]) {
                    swap(arr, j, j + 1);
                }
            }
        }
        return arr;
    },
    distinct(arr = testArr) {// 数组去重
        return arr.filter((v, i, array) => array.indexOf(v) === i)
    },
    hasProperty(obj, property){
        if(Object.prototype.toString.call(obj) !== '[object Object]'){
            return false;
        }
        if(!obj.hasOwnProperty(property))
            return false;

        return true;
    }
}
